import React from 'react';
import Referral from '@web/ui/components/card/modules/Referral.js';

export default class ShareDrawer extends React.Component {
    render() {
        const { activeDrawer, card, handleCloseDrawer } = this.props;
        return <Referral handleCloseDrawer={handleCloseDrawer} card={card} />;
    }
}
